function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./dist/ng2-pagination'));



//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/ng2-pagination/index.js
// module id = ../../../../ng2-pagination/index.js
// module chunks = vendor